<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      粤海门站<br>
站点介绍<br>
粤海门站位于深圳市南山区科苑南路与白石路呈“十”字交叉路口处，车站周边规划以大学研究院、高新科技办公楼为主。 车站为地下站，地下一层为站厅层，地下二层为站台层，共设有4个出入口。车站设有自动扶梯、垂梯、公共洗手间等便民设施。 车站以白色为主色调，立柱用湖蓝色装饰做点缀，整体利用三角体的几何元素，打造站台站厅个性区域，结合灯光设计，呈现出钻石切割面的效果，形成以创新知识为代表的特色区域。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:14	23:53	9号线	3分50秒	5分55秒<br>
文锦	06:24	23:16	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:15	23:53	9号线	4分25秒	5分55秒<br>
文锦	06:24	23:16	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:14	00:53	9号线	4分钟	5分55秒<br>
文锦	06:24	00:16	9号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
白石路南侧（西）、科苑南路西侧（南）、香港理工大学（深圳研究院）、香港中文大学、电信大厦、香港城市大学（深圳研究院）<br><br>
C出入口:<br>
白石路北侧（东）、深圳市数字技术园A区、德维森大厦、英唐大厦、科苑南路东侧<br><br>
D1出入口:<br>
科苑南路西侧（北）<br><br>
D2出入口:<br>
白石路北侧（西）、深圳清华大学研究院、深港产学研基地<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 阳光粤海大厦<br>
334、B728、M209、M528、高峰专线7、高峰专线34<br><br>
C出入口:<br>
公交站名： 深港产学研基地<br>
高峰专线22、高峰专线34、高峰专线92、高峰专线102、高峰专线138、高峰专线150、高峰专线7、高峰专线21、325、334、E9、M554、高快巴士42<br><br>
D出入口:<br>
公交站名： 白石科苑路口<br>
M209、M528、高峰专线128<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "jiuhaoxian",
            title: "9号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>